import { render } from "./TheNavbarNewsItem.pug?vue&type=template&id=5d6bef0a&lang=pug"
import script from "./TheNavbarNewsItem.js?vue&type=script&lang=js"
export * from "./TheNavbarNewsItem.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__